import baseApi from "../utils/baseApi";
import { SubscriptionPlan } from "../types/subscriptionTypes";

const ADMIN_SUBS_API = "/admin/subscription-plans";

export const getAllSubscriptionPlan = async (): Promise<SubscriptionPlan[]> => {
    try {
        const response = await baseApi.get(ADMIN_SUBS_API);
        return response.data.data; 
    } catch (error) {
        throw new Error("Failed to fetch subscription plans.");
    }
};

export const createSubscriptionPlan = async (planData: Partial<SubscriptionPlan>) => {
    try {
        const response = await baseApi.post(ADMIN_SUBS_API, planData);
        return response.data;
    } catch (error) {
        throw new Error("Failed to create subscription plan.");
    }
};

export const updateSubscriptionPlanDetail = async (id: number, planData: Partial<SubscriptionPlan>) => {
    try {
        const response = await baseApi.put(`${ADMIN_SUBS_API}/${id}`, planData);
        return response.data;
    } catch (error) {
        throw new Error("Failed to update subscription plan.");
    }
};

export const deleteSubscriptionPlan = async (id: number) => {
    try {
        const response = await baseApi.delete(`${ADMIN_SUBS_API}/${id}`);
        return response.data;
    } catch (error) {
        throw new Error("Failed to delete subscription plan.");
    }
};